import * as React from "react";
import { AssignmentDTO, ComponentModelDTO, ComponentType } from "groopit-js";
import { GroopitComponent } from "./GroopitComponent";
import { HiddenIcon } from "../Icons/HiddenIcon";
import { ComponentDataDTO } from "groopit-js/client";

interface ComponentTableProps {
  model: ComponentModelDTO;
  assignment: AssignmentDTO;
  childComponents: ComponentDataDTO[];
  allComponents: ComponentDataDTO[];
  is_creator: boolean;
  is_popover: boolean;
  groopit_id: string;
  isLinkedToSalesforce: boolean;
  openFollowUpEditor: (anchor: HTMLElement) => void;
}

export const GroopitTableComponent = (props: ComponentTableProps) => {
  const { model, childComponents } = {
    ...props,
  };

  if (childComponents.length > 0) {
    return (
      <div className="groopit-component table-component">
        {!model.isFlagField && model.type != ComponentType.FollowUpRequest && (
          <div className="text-display-caption text-app-black pt-4 pb-2">
            {model.description}
          </div>
        )}
        {model.hiddenFromMembers && (
          <div>
            <HiddenIcon className="inline mr-2 w-5" />
            <span className="text-display-caption app-gray-03">
              Hidden from members, only visible to organizers{" "}
            </span>
          </div>
        )}
        <div className="w-full grid grid-cols-2">
          {childComponents.map((component) => (
            <GroopitComponent
              key={component.model.componentModel_Id}
              {...props}
              component={component}
              model={
                new ComponentModelDTO({
                  ...component.model,
                  // These really aren't nullable in this context
                  description: component.model.description ?? "",
                  formId: model.formId,
                })
              }
            />
          ))}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
